import React, { useState } from 'react';

import dayjs from 'dayjs';
import AthleteAttendanceTableContainer from 'pages/private/owner/AthleteDetail/components/Attendance/components/AthleteAttendanceTableContainer';
import { SearchFilters } from 'pages/private/owner/AthleteDetail/components/Attendance/types';
import { AthleteRetrieve } from 'types';

import AthleteAttendanceFilters from './components/AthleteAttendanceFilters';

interface IAttendanceProps {
  athlete: AthleteRetrieve;
  permission?: boolean;
  openTabsDrawer: () => void;
}

const Attendance = ({ athlete, permission, openTabsDrawer }: IAttendanceProps): JSX.Element => {
  const today = new Date();
  const initialSearchFiltersValue: SearchFilters = {
    date: [null, today],
    eventTypes: [],
    athlete: athlete.athleteId,
  };

  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);

  return (
    <>
      <AthleteAttendanceFilters
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
        openTabsDrawer={openTabsDrawer}
      />

      <AthleteAttendanceTableContainer
        searchFilters={searchFilters}
        permission={permission}
        timeType='past'
        defaultEndDate={dayjs(today).format('YYYY-MM-DD')}
        margin={0}
        bgc={'gray'}
      />
    </>
  );
};

export default Attendance;
